import { ISOCountryCode, parseCountryCode } from '@pmi.web/countries';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { DefaultCountryAddress } from './_default/DefaultCountryAddress';
import { AUCountryAddress } from './au/AUCountryAddress';
import { CACountryAddress } from './ca/CACountryAddress';
import { JPCountryAddress } from './jp/JPCountryAddress';
import { USCountryAddress } from './us/USCountryAddress';
import { MXCountryAddress } from './mx/MXCountryAddress';
import { THCountryAddress } from './th/THCountryAddress';
import { MYCountryAddress } from './my/MYCountryAddress';
import { IDCountryAddress } from './id/IDCountryAddress';
import { HNCountryAddress } from './hn/HNCountryAddress';
import { DOCountryAddress } from './do/DOCountryAddress';
import { COCountryAddress } from './co/COCountryAddress';

export interface IAddressFormProps {
  readonly country: ISOCountryCode;
  readonly env: 'development' | 'production';
  readonly required?: boolean;
}

export function AddressInput(props: IAddressFormProps) {
  const { country, env, required = false } = props;
  const Form = getCountryForm(country);

  const { setValue } = useFormContext();

  useEffect(() => {
    setValue('address.country', country);
  }, [country, setValue]);

  return <Form env={env} isoCountryCode={country} required={required} />;
}

function getCountryForm(country: string) {
  const isoCountry = parseCountryCode(country);

  switch (isoCountry) {
    case ISOCountryCode.UnitedStatesAmerica:
      return USCountryAddress;
    case ISOCountryCode.Mexico:
      return MXCountryAddress;
    case ISOCountryCode.Japan:
      return JPCountryAddress;
    case ISOCountryCode.Canada:
      return CACountryAddress;
    case ISOCountryCode.Australia:
      return AUCountryAddress;
    case ISOCountryCode.Thailand:
      return THCountryAddress;
    case ISOCountryCode.Malaysia:
      return MYCountryAddress;
    case ISOCountryCode.Indonesia:
      return IDCountryAddress;
    case ISOCountryCode.Honduras:
      return HNCountryAddress;
    case ISOCountryCode.DominicanRepublic:
      return DOCountryAddress;
    case ISOCountryCode.Colombia:
      return COCountryAddress;
    default:
      return DefaultCountryAddress;
  }
}
